import React, {Component} from 'react';
import {Button, Form, Header, Icon, Image, Label, Message, Modal, Segment} from 'semantic-ui-react';
import moment from "moment";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import {availLeaveOnDate} from "../../../data/user_api";
import {LEAVE_APPLICATION_URL} from "../../../constants/api_routes";
import Loader from "../../universal/loader";
import AvailLeave from './avail_leave';

class ClerkLeaveRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStatus: undefined,
            updateSuccess: false,
            leaveDate:undefined,
            leaveStartTime:moment().hours(8).minute(0).format("YYYY-MM-DD HH:mm"),
            leaveEndTime:moment().hours(17).minute(0).format("YYYY-MM-DD HH:mm"),
            dateValid:true,
            timeValid:true,
            disableSubmit:false
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if(!this.state.leaveDate){
            this.setState({dateValid:false});
            return;
        }
        if(!this.state.leaveStartTime || !this.state.leaveEndTime){
            this.setState({timeValid:false});
            return;
        }
        this.setState({isSaving: true});
        let formData = new FormData(event.target);
        formData.append("clerk_profile_id", this.props.clerkId.toString());
        formData.append("start_time", this.state.leaveStartTime);
        formData.append("end_time", this.state.leaveEndTime);
        formData.append("is_available",false);

        if (this.props.clerkId && this.state.leaveDate && this.state.leaveStartTime && this.state.leaveEndTime) {
            availLeaveOnDate(LEAVE_APPLICATION_URL, this.props.clerkId, formData).then((result)=>{
                this.props.close();
            });
        }
        else {
            this.setState({dateValid: false});
        }
    };

    onStartChange = (value) => {
        if(!this.state.leaveDate){
            this.setState({dateValid:false});
            return;
        }
        if(value) {
            this.setState({leaveStartTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm"),leaveEndTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).add(8,"hour").format("YYYY-MM-DD HH:mm")});
        }
        else {
            this.setState({leaveStartTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(8).minute(0).format("YYYY-MM-DD HH:mm"),leaveEndTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm")});
        }
    };

    onEndChange = (value) => {
        if(value) {
            this.setState({leaveEndTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm")});
        }
        else {
            this.setState({leaveEndTime: moment(this.state.leaveDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm")});
        }
    };

    disabledHours = () => {
        return [0,1,2,3,4,5,6];
    };

    render() {
        const timeFormat = 'HH:mm';
        return (
            <div className="additional-pad">
                {this.state.isSaving && <Loader save={true}/>}
                <Modal size="fullscreen" open={true} onClose={(e) => {
                   this.props.close()
                }}>
                    <Modal.Content>
                        <div className="modal-close-button">
                            <Button basic icon negative onClick={(e) => {
                                this.props.close()
                            }}><Icon name="close"/></Button>
                        </div>
                        <Modal.Description>
                            <Header textAlign='center' size='large'>Record Leave</Header>
                            <Segment>
                                <Form onSubmit={this.handleSubmit}>
                                    <div>
                                        <div className='ui field'>
                                            <span className='required field'><label><b>Date of Leave: </b></label></span><span className={this.state.dateValid?'field':'field ui error'}><DayPickerInput
                                            placeholder="DD-MM-YYYY"
                                            dayPickerProps={{
                                                todayButton: 'Today',
                                                firstDayOfWeek : 1,
                                            }}
                                            format="DD-MM-YYYY"
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            value={this.state.leaveDate}
                                            onDayChange={day => {if(day) { this.setState({
                                                leaveDate: day,
                                                dateValid:true,
                                                leaveStartTime:moment(day).hour(parseInt(moment(this.state.leaveStartTime).format("HH"))).minute(parseInt(moment(this.state.leaveStartTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                                                leaveEndTime:moment(day).hour(parseInt(moment(this.state.leaveEndTime).format("HH"))).minute(parseInt(moment(this.state.leaveEndTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                                            })}
                                            else {
                                                this.setState({dateValid:false,leaveDate:undefined});
                                            }
                                            }}/></span>
                                        </div>
                                        <div style={{height:'50px'}}>
                                        {this.state.leaveDate &&
                                        <Form.Group inline>
                                            <Label content='From :'/>
                                            <TimePicker
                                                showSecond={false}
                                                defaultValue={moment().hour(8).minute(0)}
                                                placeholder="8:00"
                                                className="time-width"
                                                onChange={this.onStartChange}
                                                disabledHours={this.disabledHours}
                                                format={timeFormat}
                                                minuteStep={15}
                                                inputReadOnly
                                                hideDisabledOptions
                                            /><span>--</span>
                                            <Label content='To :'/>
                                            <TimePicker
                                                showSecond={false}
                                                defaultValue={moment().hour(17).minute(0)}
                                                placeholder='17:00'
                                                className="time-width"
                                                onChange={this.onEndChange}
                                                disabledHours={this.disabledHours}
                                                format={timeFormat}
                                                minuteStep={15}
                                                inputReadOnly
                                                hideDisabledOptions
                                            />
                                        </Form.Group>
                                        }
                                        </div>
                                    </div>
                                    <Form.TextArea name='description' label="Add Note"
                                                   placeholder="Reason for leave?"/>
                                    <div className="right-aligned">
                                        <Button disabled={this.state.disableSubmit} primary content='Record Leave'/>
                                    </div>
                                </Form>
                            </Segment>
                        <AvailLeave clerkId={this.props.clerkId}></AvailLeave>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}

export default ClerkLeaveRecord;




// WEBPACK FOOTER //
// ./src/views/user/clerk/record_leave.js